<section class="lightSection pageHeader">
  <div class="container">
    <div class="row">
      <div class="page-title col-md-5">
        @if (showTitle) {
          <h1>{{titleService.title}}</h1>
        }
      </div>
      <div class="breadcrumb col col-md-7">
        <ol>
          <li>
            <a routerLink="/" routerLinkActive="active">Home</a>
          </li>
          @if (breadcrumbService.safeUri !== null) {
            <li class="active">
              <a [routerLink]="breadcrumbService.safeUri" routerLinkActive="active">{{breadcrumbService.breadcrumb}}</a>
            </li>
          }
          @if (breadcrumbService.safeUri === null) {
            <li class="active">{{breadcrumbService.breadcrumb}}</li>
          }
        </ol>
      </div>
    </div>
  </div>
</section>